/**
 * IndexNow client-side ping utility
 * Submits important URLs to search engines for faster indexing
 */
import { supabase } from "@/integrations/supabase/client";

const PING_COOLDOWN_MS = 60_000; // 1 min between pings per URL
const MAX_BATCH = 20;
const pingedUrls = new Map<string, number>();

/** Submit URLs to IndexNow via edge function (deduped + throttled) */
export async function pingIndexNow(paths: string[]) {
  // Only ping on production
  if (typeof window === 'undefined') return;
  const hostname = window.location.hostname;
  if (!hostname.includes('yachtvalues.com') && !hostname.includes('boatvalue.com')) return;

  const now = Date.now();
  const urls = paths
    .map(p => `https://yachtvalues.com${p.startsWith('/') ? p : `/${p}`}`)
    .filter(url => {
      const last = pingedUrls.get(url);
      return !last || now - last > PING_COOLDOWN_MS;
    })
    .slice(0, MAX_BATCH);

  if (urls.length === 0) return;

  // Mark as pinged immediately (optimistic)
  urls.forEach(url => pingedUrls.set(url, now));

  try {
    await supabase.functions.invoke('indexnow-submit', {
      body: { urls },
    });
  } catch {
    // Silent fail — indexing is best-effort
  }
}

/** Ping the current page URL (useful on route changes) */
export function pingCurrentPage() {
  if (typeof window === 'undefined') return;
  pingIndexNow([window.location.pathname]);
}
